/** Logical storage containers / path prefixes (persisted in DB and Azure container names). */
export enum StorageLogicalBucket {
    /** Resumes, offer docs, WhatsApp/Naukri uploads, etc. */
    DOCUMENTS = 'demodocs',
    STATIC = 'static',
    RECORDINGS = 'recordings',
}

export const STORAGE_LOGICAL_BUCKET_VALUES = Object.values(StorageLogicalBucket) as StorageLogicalBucket[]

export function isStorageLogicalBucket(value: string): value is StorageLogicalBucket {
    return STORAGE_LOGICAL_BUCKET_VALUES.includes(value as StorageLogicalBucket)
}
